export default __webpack_public_path__ + "static/media/neck-mint.222d0772.png";